export const state = {
  mainIndicators: []
}
